export default "__VITE_ASSET__2qsgISSs7gg5PPxNsWY0nA__";